import { CTA, Text, TextTag, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import * as React from 'react';

import { useUniversalEffect } from '@volkswagen-onehub/vw-starter-feature-app-support';
import { OfertasContext } from './context/ofertas-context';

export const Subpage = () => {
	const { logger = console, breacrumbService, pageInfoService, historyService } = React.useContext(OfertasContext);

	useUniversalEffect(() => {
		breacrumbService.set([
			{
				href: '/mysubpage',
				label: 'subpage',
				onClick: () => {
					alert('this is a dummy subpage');
				},
			},
		]);
		pageInfoService.setPageInfo({ seo: { pageTitle: 'My Feature App Title' } });
		console.log('info is set');
	}, [logger, pageInfoService, breacrumbService]);

	return (
		<div>
			<Text tag={TextTag.h1} appearance={TokenTextAppearance.headline400}>
				<strong>Volkswagen OneHub</strong> Esofertasv2 Feature App
			</Text>
			<Text tag={TextTag.h2} appearance={TokenTextAppearance.headline200}>
				This is a sub page with a different title and breadcrumb.
			</Text>
			<CTA
				tag="a"
				emphasis="secondary"
				onClick={(e) => {
					historyService.history.push('/');
					e.preventDefault();
				}}
			>
				back home
			</CTA>
		</div>
	);
};
